import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/pages/auth/auth.context";

export function useGenerateChecks(batchId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data } = await axiosInstance.post(
        `/check-batches/${batchId}/generate`,
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["checkBatch", batchId] });
      queryClient.invalidateQueries({
        queryKey: ["checkBatchStatistics", batchId],
      });
    },
  });
}
